import React, { useCallback, useEffect, useState } from 'react';
import { Badge, Banner, BlockStack, Card, InlineStack, Spinner, Text } from '@shopify/polaris';
import { rentalsAPI } from '../services/api';
import RentalDetailModal from '../components/RentalDetailModal';
import RentalOverviewCard from '../components/RentalOverviewCard';

const CurrentlyRentedOut = () => {
  const [rentals, setRentals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedRental, setSelectedRental] = useState(null);

  const fetchRentedOut = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      const response = await rentalsAPI.getCurrent({ view: 'active' });
      setRentals(response.data?.active || []);
    } catch (err) {
      setError('Failed to load rented-out products');
      console.error('Currently rented out error:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchRentedOut();
  }, [fetchRentedOut]);

  if (loading) {
    return (
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: 40, textAlign: 'center' }}>
        <Spinner size="large" />
        <br />
        <Text variant="bodyMd" tone="subdued">Loading currently rented-out products...</Text>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto' }}>
      <BlockStack gap="400">
        <InlineStack align="space-between" blockAlign="center">
          <Text variant="headingLg">Currently Rented Out</Text>
          <Badge>{rentals.length}</Badge>
        </InlineStack>

        {error && <Banner tone="critical" onDismiss={() => setError('')}>{error}</Banner>}

        {rentals.length === 0 ? (
          <Card><Text variant="bodyMd" tone="subdued">No products are currently rented out.</Text></Card>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(360px, 100%), 1fr))', gap: 16 }}>
            {rentals.map((rental) => (
              <RentalOverviewCard
                key={rental.id}
                rental={rental}
                mode="active"
                onView={setSelectedRental}
              />
            ))}
          </div>
        )}

        <RentalDetailModal
          rental={selectedRental}
          open={Boolean(selectedRental)}
          onUpdated={(updated) => { setSelectedRental(updated); fetchRentedOut(); }}
          onClose={() => setSelectedRental(null)}
        />
      </BlockStack>
    </div>
  );
};

export default CurrentlyRentedOut;
